module.exports = __webpack_public_path__ + "static/img/service_cont_03_zh.eb7c0b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_cont_03_zh.png
// module id = WJuR
// module chunks = 34